<template>
  <div class="wrapper">
    <button class="rating-icon" :class="classNames" @click="onClick(rating.value)">
      <VeryHappyIcon v-if="rating.id === 'very-happy'" />
      <HappyIcon v-if="rating.id === 'happy'" />
      <IndifferentIcon v-if="rating.id === 'indifferent'" />
      <UnhappyIcon v-if="rating.id === 'unhappy'" />
      <VeryUnhappyIcon v-if="rating.id === 'very-unhappy'" />
    </button>
  </div>
</template>

<script>
import VeryHappyIcon from './icon-very-happy.svg';
import HappyIcon from './icon-happy.svg';
import IndifferentIcon from './icon-indifferent.svg';
import UnhappyIcon from './icon-unhappy.svg';
import VeryUnhappyIcon from './icon-very-unhappy.svg';

export default {
  name: 'EClimateRating',
  components: {
    VeryHappyIcon,
    HappyIcon,
    IndifferentIcon,
    UnhappyIcon,
    VeryUnhappyIcon,
  },
  props: {
    rating: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      required: true,
    },
    isTouched: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classNames() {
      let className = `${this.rating.id}`;
      if (this.isActive || !this.isTouched) {
        className += ' active';
      }
      if (!this.isActive && this.isTouched) {
        className += ' inactive';
      }
      return className;
    },
  },
  methods: {
    click() {},
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-right: $space-m;
}

.rating-icon {
  border: none;
  background: none;
  padding: 0;
}

svg {
  cursor: pointer;
  fill: var(--color-button-content-primary);
  transition: fill $timing-s $easing;
}

.inactive {
  circle:first-child {
    stroke: $c-gray-40;
  }

  svg {
    &:hover {
      circle:first-child {
        stroke: none;
      }
    }
  }
}

.very-happy {
  .icon-very-happy-rating-svg {
    &:hover {
      fill: $c-green-30;
      opacity: $opacity-l;
    }
  }
}

.very-happy.active {
  .icon-very-happy-rating-svg {
    fill: $c-green-30;
  }
}

.happy {
  .icon-happy-rating-svg {
    &:hover {
      fill: $c-light-green-40;
      opacity: $opacity-l;
    }
  }
}

.happy.active {
  .icon-happy-rating-svg {
    fill: $c-light-green-40;
  }
}

.indifferent {
  .icon-indifferent-rating-svg {
    &:hover {
      fill: $c-yellow-40;
      opacity: $opacity-l;
    }
  }
}

.indifferent.active {
  .icon-indifferent-rating-svg {
    fill: $c-yellow-40;
  }
}

.unhappy {
  .icon-unhappy-rating-svg {
    &:hover {
      fill: $c-red-30;
      opacity: $opacity-l;
    }
  }
}

.unhappy.active {
  .icon-unhappy-rating-svg {
    fill: $c-red-30;
  }
}

.very-unhappy {
  .icon-very-unhappy-rating-svg {
    &:hover {
      fill: $c-red-40;
      opacity: $opacity-l;
    }
  }
}

.very-unhappy.active {
  .icon-very-unhappy-rating-svg {
    fill: $c-red-40;
  }
}
</style>
